import { Suspense, useEffect } from 'react'
import { get } from 'lodash'
import { useNavigate, useParams } from 'react-router-dom'

import { loaderStore } from '@/store/LoaderStore'
import { motorTradeFormStore } from '@/store/MotorTradeFormStore'
import { MotorTradeBuyRouter } from '@/router/motorTradeBuyRouter'

const brokerBaseURL = import.meta.env.VITE_COVERX_BROKER_DASH
const brokerDashboardURL = brokerBaseURL + '/broker/dashboard'

const MotorTradeBuyRouteController = () => {
  const { step } = useParams()
  const stepIndex = motorTradeFormStore().step
  const { setQuotesLoading } = loaderStore.getState()

  const brokerLogged = sessionStorage.getItem('authBroker')
  const bakcofficeLogged = sessionStorage.getItem('authBO')

  const navigate = useNavigate()
  // const location = useLocation()
  const { stepAsEnum } = motorTradeFormStore()
  // const { setGuid, guid } = brokerGuidStore()

  const RenderStep = get(get(MotorTradeBuyRouter(), step || ''), 'element')

  const stepManager = (goTo: string) => {
    navigate(goTo)
  }

  useEffect(() => {
    if (!brokerLogged && !bakcofficeLogged) {
      setQuotesLoading(true)
      window.location.href = brokerDashboardURL
    }
  }, [])

  useEffect(() => {
    // if (location.state?.from !== 'commercialCombined' && guid) {
    //   setGuid(undefined)
    // }

    const step1 = MotorTradeBuyRouter().step1.href

    // if there is no steps
    if (!RenderStep || !step) {
      stepManager(step1)
    }

    // ignore someone change steps via url
    if (step) {
      const numberOfStep = step
      if (numberOfStep !== stepAsEnum) {
        const goTo = MotorTradeBuyRouter()[stepAsEnum]
        stepManager(goTo.href)
      }
    }
  }, [])

  return (
    <>
      {RenderStep && (
        <Suspense>
          <div className="ps-3 mt-1 mb-4 small">Step {stepIndex} of 14</div>

          <RenderStep />
        </Suspense>
      )}
    </>
  )
}

export default MotorTradeBuyRouteController
